import { createAsyncThunk } from "@reduxjs/toolkit";
import { DeleteCategory } from "./categorySlice";
import { ApiResponse } from "../../../types/APIResponse";
import api from "../../../utils/constants/api";
import { apiEndpoints } from "../../../utils/constants/apiEndpoints";
import { IAuthResponse } from "../auth/IAuthState";
import { Category } from "../../../types";

// Async Thunks
export const fetchCategories = createAsyncThunk<Category[], void, { rejectValue: string }>(
    'categories/fetchCategories',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get<ApiResponse<Category[]>>(apiEndpoints.category.getAll);
            return response.data; // Access the `data` field containing the categories
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch categories');
        }
    }
);

export const addCategory = createAsyncThunk<Category, { name: string, translationKey?: string, nameTranslations?: Record<string, string>, status?: number }, { rejectValue: string }>(
    'categories/addCategory',
    async (newCategory, { rejectWithValue }) => {
        try {
            const response = await api.post<ApiResponse<Category>>(apiEndpoints.category.create, { data: newCategory });
            return response.data; // Access the `data` field containing the created category
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to add category');
        }
    }
);

export const updateCategory = createAsyncThunk<Category, { id: string; name: string, status: number, translationKey?: string, nameTranslations?: Record<string, string> }, { rejectValue: string }>(
    'categories/updateCategory',
    async ({ id, name, status, translationKey, nameTranslations }, { rejectWithValue }) => {
        try {
            const response = await api.put<ApiResponse<Category>>(`${apiEndpoints.category.update}/${id}`, { data: { name, status, translationKey, nameTranslations } });
            return response.data; // Access the `data` field containing the updated category
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to update category');
        }
    }
);

export const deleteCategory = createAsyncThunk<DeleteCategory, { id: string }, { rejectValue: string }>(
    'categories/deleteCategory',
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await api.delete<ApiResponse<DeleteCategory>>(`${apiEndpoints.category.delete}/${id}`);
            return { ...response.data, id }; // Access the `data` field containing the deleted category
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to delete category');
        }
    }
);
